import { useState, useRef, useEffect, useCallback } from 'react';
import { MONACO_LAYOUT_FLUSH_EVENT } from '../ui/ResizableSplitter';
import { AI_PANEL_WIDTH_KEY } from './aiChatConstants';
import { clampPanelWidth, loadPanelWidth } from './panelWidth';

/** Drag-to-resize for the AI panel; the width persists in localStorage. */
export function useAiPanelResize() {
  const [panelWidth, setPanelWidth] = useState(loadPanelWidth);
  const [isResizing, setIsResizing] = useState(false);
  const panelWidthRef = useRef(panelWidth);

  useEffect(() => {
    panelWidthRef.current = panelWidth;
  }, [panelWidth]);

  const handleResizeStart = useCallback((e) => {
    e.preventDefault();
    setIsResizing(true);
    const startX = e.clientX;
    const startWidth = panelWidthRef.current;

    const onMove = (ev) => {
      const delta = startX - ev.clientX;
      const next = clampPanelWidth(startWidth + delta);
      panelWidthRef.current = next;
      setPanelWidth(next);
    };

    const onUp = () => {
      setIsResizing(false);
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
      try {
        localStorage.setItem(AI_PANEL_WIDTH_KEY, String(panelWidthRef.current));
      } catch {
        /* ignore */
      }
      window.dispatchEvent(new CustomEvent(MONACO_LAYOUT_FLUSH_EVENT));
    };

    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';
  }, []);

  return { panelWidth, isResizing, handleResizeStart };
}
